module.exports = __webpack_public_path__ + "img/wizard_video3.66bfd1fa.png";